import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CompanyManageService } from '../../../service/api/jubili/company-manage.service';
import { SettingFormByLanguageModel, UpdateCompanyFormBody, UpdateCompanyFormModel } from '../../../model/jubili/company-manage/company-setting-form-data';
import { LocalStorageService } from 'angular-2-local-storage';
import { UpdateAccessCompanyModel } from '../../../model/jubili/company-manage/update-access-company.model';

@Component({
  selector: 'jubili-edit-company-form-modal',
  templateUrl: './jubili-edit-company-form-modal.component.html',
  styleUrls: ['./jubili-edit-company-form-modal.component.scss']
})
export class JubiliEditCompanyFormModalComponent implements OnInit {
  
  private ngbModalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private companyManageService: CompanyManageService,
    private localStorageService: LocalStorageService
  ) { }

  @ViewChild("content") content: any;
  @Output('resultUpdate') resultUpdate = new EventEmitter<boolean>();
  formType: number;
  formTypeName: string;
  currentThaiForm: number;
  currentEngForm: number;
  currentCnForm: number;
  companySurrKey: number;
  userSurrKey: number;
  updateCompanyFormBody: UpdateCompanyFormBody = new UpdateCompanyFormBody();
  ngOnInit() {
    this.userSurrKey = this.localStorageService.get('userSurrKey');
  }
  public show(formtype: number, formTypeName: string, companySurrKey: number, formLanguageData: Array<SettingFormByLanguageModel>): void {
    this.formType = formtype;
    this.formTypeName = formTypeName;
    this.companySurrKey= companySurrKey;
    this.currentThaiForm = formLanguageData.find(f => f.formLanguage == 1).formSurrKey || 0;
    this.currentEngForm = formLanguageData.find(f => f.formLanguage == 2).formSurrKey || 0;
    this.currentCnForm = formLanguageData.find(f => f.formLanguage == 3).formSurrKey || 0;
    this.ngbModalRef = this.modalService.open(this.content, { centered: true });
  }
  public hide(): void {
    this.ngbModalRef.close();
  }
  onSelectThaiForm(value: number) {
    // console.log(value)
    this.currentThaiForm = value;
  }
  onSelectEngForm(value: number) {
    this.currentEngForm = value;
  }
  onSelectCnForm(value: number) {
    this.currentCnForm = value;
  }
  assignDataToModel(){
    this.updateCompanyFormBody.companySurrKey = this.companySurrKey;
    this.updateCompanyFormBody.userSurrKey = this.userSurrKey;

    let thaiModel = new UpdateCompanyFormModel();
    thaiModel.formLanguage = 1;
    thaiModel.formType = this.formType;
    thaiModel.formSurrKey = this.currentThaiForm;

    let engModel = new UpdateCompanyFormModel();
    engModel.formLanguage = 2;
    engModel.formType = this.formType;
    engModel.formSurrKey = this.currentEngForm;

    let cnModel = new UpdateCompanyFormModel();
    cnModel.formLanguage = 3;
    cnModel.formType = this.formType;
    cnModel.formSurrKey = this.currentCnForm;
    this.updateCompanyFormBody.companyFormModels = new Array<UpdateCompanyFormModel>();
    this.updateCompanyFormBody.companyFormModels.push(thaiModel);
    this.updateCompanyFormBody.companyFormModels.push(engModel);
    this.updateCompanyFormBody.companyFormModels.push(cnModel);
  }
  submit() {
    this.assignDataToModel();
    this.updateCompanyForm();
  }
  updateCompanyForm() {
    this.companyManageService.updateCompanyForm(this.updateCompanyFormBody).subscribe(res => {
      this.resultUpdate.emit(res);
    },
    error => {

    })
  }
}
